module.exports = __webpack_public_path__ + "static/media/reedIOFT1027.67226849.ico";